module.exports = __webpack_public_path__ + "static/media/Encore_Consent-Form-Professionals_ENG_jan2021.9d15d4d0.pdf";